import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=aa388dd6&scoped=true"
import script from "./legal.ts?vue&type=script&lang=ts&external"
export * from "./legal.ts?vue&type=script&lang=ts&external"
import style0 from "./Legal.vue?vue&type=style&index=0&id=aa388dd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa388dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa388dd6')) {
      api.createRecord('aa388dd6', component.options)
    } else {
      api.reload('aa388dd6', component.options)
    }
    module.hot.accept("./Legal.vue?vue&type=template&id=aa388dd6&scoped=true", function () {
      api.rerender('aa388dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/legal/Legal.vue"
export default component.exports